import { useTheme } from "@mui/material";
import WoPrintOnBackPage1 from "assets/print-templates/work-orders-po/back/WoPrintOnBack_Page1.jpg";
import WoPrintOnBackPage2 from "assets/print-templates/work-orders-po/back/WoPrintOnBack_Page2.jpg";
import { observer } from "mobx-react-lite";
import { IWorkOrderPo } from "mobx-stores/_models/work-order-po/work-order-po";
import { useStores } from "mobx-stores/_root-store";
import { useCallback, useMemo } from "react";
import {
  PrintMultiplePageItem,
  PrintMultiplePagePreview,
} from "share-components/templates/print/print-multiple-page-preview";
import { useBackPage1Elements } from "./hooks/use-back-page-1-elements";
import { useBackPage2Elements } from "./hooks/use-back-page-2-elements";

export const PrintOnBackPreview = observer(() => {
  const {
    workOrderPoManagement: {
      workOrderPoPrintingManagement: { openPrintOnBackPreview, setProp },
      workOrderPoDetail,
    },
  } = useStores();

  const theme = useTheme();

  const onCloseHandler = useCallback(() => {
    setProp("openPrintOnBackPreview", false);
  }, [setProp]);

  const { backPage1Elements } = useBackPage1Elements({
    workOrderPoDetail: workOrderPoDetail as IWorkOrderPo,
  });

  const { backPage2Elements } = useBackPage2Elements({
    workOrderPoDetail: workOrderPoDetail as IWorkOrderPo,
  });

  const pages = useMemo<PrintMultiplePageItem[]>(() => {
    return [
      {
        key: "back-page-1",
        elements: backPage1Elements,
        templateImage: WoPrintOnBackPage1,
        backgroundSize: "100%",
        backgroundPosition: "inherit",
      },
      {
        key: "back-page-2",
        elements: backPage2Elements,
        templateImage: WoPrintOnBackPage2,
        backgroundSize: "100%",
        backgroundPosition: "inherit",
      },
    ];
  }, [backPage1Elements, backPage2Elements]);

  return (
    <PrintMultiplePagePreview
      open={openPrintOnBackPreview}
      printIncludeTemplate={true}
      pages={pages}
      editorOptions={{
        enabled: true,
      }}
      mode="portrait"
      fontSize="16px"
      paperSize={{
        width: "21cm",
        height: "29.7cm",
      }}
      sx={{
        fontFamily: `"Times New Roman", Times, ${theme.typography.fontFamily} !important`,
      }}
      onClose={onCloseHandler}
    />
  );
});
